import { memo } from "react";

import { Trans } from "react-i18next";

import ContactUs from "./ContactUs";

const UnsupportedBrowserMessage = ({
  browserName,
  browserVersion,
  className = "",
}) => (
  <Trans
    components={{ contactUs: <ContactUs {...{ className }} /> }}
    i18nKey="neetoMolecules.browserSupport.unsupportedBrowser.description"
    values={{ browserName, browserVersion }}
  />
);

export default memo(UnsupportedBrowserMessage);
